import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faGripLinesVertical, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { AttributesSelectionResult } from 'src/app/controls/attributes-selection/models/attributes-selection-result';
import { Attribute } from 'src/app/models/attribute';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
    selector: 'app-attributes-selector',
    imports: [CdkDropList, CdkDrag, FaIconComponent, CdkDragHandle],
    templateUrl: './attributes-selector.component.html',
    styleUrl: './attributes-selector.component.scss'
})
export class AttributesSelectorComponent {
    /**
     * Icones utilisées dans le composant.
     */
    public dragIcon = faGripLinesVertical;
    public deleteIcon = faTrash;
    public addIcon = faPlus;

    /**
     * Titre du composant.
     */
    @Input()
    public title: string = '';

    /**
     * Liste des attributs disponibles.
     */
    @Input()
    public attributes: Attribute[] = [];

    /**
     * Liste des attributs sélectionnés.
     */
    @Input()
    public selectedAttributes: Attribute[] = [];

    /**
     * Emis lorsqu'un attribut est ajouté, supprimé ou déplacé.
     */
    @Output()
    public attributesChanged = new EventEmitter<Attribute[]>();

    /**
     * Constructeur.
     * @param dialogService
     */
    public constructor(private dialogService: DialogService) {}

    /**
     * Appelée lorsqu'un attribut est déplacé.
     * @param event : événement de déplacement.
     */
    public onDropAttribute(event: CdkDragDrop<Attribute[]>) {
        moveItemInArray(this.selectedAttributes, event.previousIndex, event.currentIndex);
        this.attributesChanged.emit(this.selectedAttributes);
    }

    /**
     * Appelée lorsqu'un attribut est supprimé.
     * @param attributeId : Id de l'attribut à supprimer.
     */
    public onRemoveAttribute(attributeId: number) {
        this.selectedAttributes = this.selectedAttributes.filter((x) => x.id !== attributeId);
        this.attributesChanged.emit(this.selectedAttributes);
    }

    /**
     * Appelée lorsqu'un attribut est ajouté.
     */
    public onAddAttribute() {
        let remainningAttributes = this.attributes.filter((x) => !this.selectedAttributes.some((y) => y.id === x.id));
        const dialogRef = this.dialogService.openAttributesSelection(remainningAttributes).subscribe((x: AttributesSelectionResult) => {
            if (!!x) {
                this.selectedAttributes = this.selectedAttributes.concat(...x.selectedAttributes);
                this.attributesChanged.emit(this.selectedAttributes);
            }
        });
    }
}
